module.exports = __webpack_public_path__ + "img/b9617.3985c74f.svg";